import type { SheetThicknessInputs, SheetThicknessResult } from "./types";

const JULES_FACTOR = 0.83;

export const sheetThicknessPresets = [3, 4, 5, 6, 8, 10, 12, 15, 20, 25, 30] as const;

export function calculateSheetThickness(inputs: SheetThicknessInputs): SheetThicknessResult {
  const normMin = inputs.aMass / 0.7;
  const normMax = inputs.aMass ** 2 + 0.5;
  const julesMin = normMin * JULES_FACTOR;

  return {
    recommendedMin: Math.floor(julesMin),
    recommendedMax: Math.ceil(normMax),
    normMin,
    normMax,
    julesMin,
    julesFactor: JULES_FACTOR
  };
}

export function calculateSheetThicknessForAMass(aMass: number) {
  return calculateSheetThickness({ aMass });
}
